/// <reference lib="es2015" />
export default import('./index').then(function (mod) {
  return mod.default;
});